// src/GlobalStyle.js
import { createGlobalStyle } from 'styled-components';

export const GlobalStyle = createGlobalStyle`
  :root {
    --background-color-sidebar: #1d1d1d;
    --background-color-main: #121212;
    --background-color-container: #1a1a1a;
    --lines-color-main: #444444;
    --correctly-typed-color: #444444;
    --incorrectly-typed-color: #f27474;
    --hover-border-color: #bb86fc;
    --text-color-white: #FFF;
    --hover-background-color: rgba(255, 255, 255, .075);
    --h5-font-size-desktop: 16px;
    --h2-font-size-desktop: 32px;
    --untyped-text-color: #E0E0E0; 

  }
  * {
    margin: 0; padding: 0;
    box-sizing: border-box;
    font-family: 'Roboto Mono', monospace;
  }
  body {
    background-color: var(--background-color-main);
    color: var(--text-color-white);
    min-height: 100vh;
  }
  a { text-decoration: none; color: var(--text-color-white); }
`;
